import SelectType from "../SelectType"
import { COMPONENTS_TYPES } from "../../../config/constants"


export default function SelectCustomOrlaw(): JSX.Element {
    return (
        <SelectType type={COMPONENTS_TYPES.SELECT_CUSTOM_OR_LAW} />
    )
}